var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visits"},[_c('h2',{staticClass:"profile__header"},[_vm._v(_vm._s(_vm.$t('nav.recordsOld')))]),_c('div',{staticClass:"row"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }